













































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { SendTestMailQuery } from '@/agiles/common';

@Component
export default class TenantSettingsEditor extends Vue {
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true];
  public item: Common.TenantSettings = null;
  public changeBeforeElectronicBookMode: boolean = false;
  public usedTypes = Common.UsedTypes;
  public optionFlags = Common.optionFlags;
  public hasLicenseCurrency:boolean = false;
  public hasLicensePrime:boolean = false;
  public get perm(){return 'system.menu_tenant_setting.edit';}
  public created() {
    this.changeBeforeElectronicBookMode = this.$api.tenantSettings.electronicBookMode;
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicensePrime = this.$api.hasLicense(Common.licenseFlags.prime);
    //テナント設定をロードする
    this.$api.formatter.ensureListLoaded("currency")
    .then(()=>this.$api.execute(new Common.TenantSettingsLoadQuery()))
    .then(res => this.item = res );
    if (this.$route.query.error){
      this.$router.push(this.$route.path,()=>{
        this.$api.modal.showDialog('無効な操作','連携の設定に失敗しました。');
        return;
      });
    }
    else if (this.$route.query.state){
       //stateパラメータの2つ目をとる
        let accountApiType = Number.parseInt((this.$route.query.state as string).split('|')[1]);
        
        if(accountApiType ==  Common.accountApiTypes.freee && this.$route.query.code){
        this.$api.execute(new Common.GetFreeeCompaniesQuery(this.$route.query.code as string, accountApiType)).then(res => {
          this.showFreeeCompanyDialog = true;
          this.freeCompanies = new Array;
          (res as Common.FreeCompany[]).forEach(el => {
            this.freeCompanies.push(new Common.BindItem(el.id,el.name));
          });
        });
      }else if(accountApiType ==  Common.accountApiTypes.moneyLook){
        this.$api.execute(new Common.SetMoneyLookAccessTokenQuery()).then(res => {
          this.reload();
        });
      }else if (accountApiType == Common.accountApiTypes.smtp){
        var source = JSON.parse(atob((this.$route.query.state as string).split('|')[2])) as Common.SmtpSetupQuery;
        var query = new Common.SmtpSetupQuery();
        query.smtpProviderFlag = source.smtpProviderFlag;
        query.mailId = source.mailId;
        query.replyId = source.replyId;
        query.smtpUid = source.smtpUid;
        query.authorizeCode = this.$route.query.code as string;
        
        this.$api.execute(query).then(res =>{          
          this.$router.push(this.$route.path);//パラメーターを除外   
          this.$api.modal.show('メールサーバー設定','設定を更新し、テストメールを送信しました。メールを確認してください。',true,null);       
        }).catch(err =>{
          this.$router.push(this.$route.path);//パラメーターを除外             
        });             
      }
    }
    this.$set(this.tabVisibles, 2, this.$api.useOperationFunction);
    this.$set(this.tabVisibles, 3, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction);
  }
  public companies(){
    return this.freeCompanies;
  }

  public async onExec(item: any) {
    console.log(this.changeBeforeElectronicBookMode +' _&_ '+this.item.electronicBookMode);
    if(this.changeBeforeElectronicBookMode != item.electronicBookMode) {
      var message = '';
      if(item.electronicBookMode == true)
        message ='電子帳簿保存法の対応として、確定した伝票を元に発行した帳票(pdf)が自動的に添付ファイルとして保存されます。それによりストレージが使用され、追加ストレージが必要になることがあります。\r\n※エクセル出力した帳票は自動登録されません。手動で添付ファイルに登録してください。';
      else
        message ='電子帳簿保存法対応の設定が「対応しない」に更新されます。帳票の自動添付がされなくなり、電子帳簿保存法の要件を満たさなくなりますが本当によろしいですか？';
      this.$api.modal.showDialog('確認',message,false)
        .then(() => this.$api.update(item).then(obj => {
          (this.$refs.editor as Components.Editor).setState(Common.editorStates.Read);
          this.reload();
        }))
        return;
      }else{
        return this.$api.update(item).then(obj => {
          (this.$refs.editor as Components.Editor).setState(Common.editorStates.Read);
          this.reload();
        });
      }
  }

  public reload() {
    //テナント設定をロードする
    this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => {
      this.changeBeforeElectronicBookMode = res.electronicBookMode;
      this.item = res;
      this.$api.tenantSettings=this.item;
      this.$api.wordsReload();
    });
  }

  public propValue :Common.UsedTypes;
  public showDialog :boolean = false;
  public dialogTitle:string = null;
  public targetProperty:string = null;
  public alertMessage:string = null;
  public showDialog2:boolean = false;
  public accountApiType:Common.accountApiTypes;
  public showAccountSettingDialog:boolean = false;

  public freeCompanies:Common.BindItem[] = null;
  public showFreeeCompanyDialog:boolean = false;
  public freeCompayId:string='';
  public freeeDealsApi:boolean = false;

  public showMoneyLookDialog:boolean = false;
  public moneyLookConsumerKey:string='';
  public moneyLookConsumerSecret:string='';

  public dataMigrationType:Common.dataMigrationTypes = Common.dataMigrationTypes.none;
  public dataMigrationTypes=Common.dataMigrationTypes;

  public onClick(title:string, property : string) {
      this.dialogTitle = title;
      this.propValue = Common.UsedTypes.None;
      this.targetProperty = property;
      this.showDialog = true;
  }
  public onExecute() {
    this.alertMessage =String.format( '予備項目の割当解除は行えません。\r\n{0}を{1}に割当てよろしいですか？',  this.$api.getWord(this.dialogTitle), this.$api.formatter.formatByList(this.propValue, 'usedTypes'));
    this.showDialog = false;
    this.$nextTick(()=>this.showDialog2 = true);
  }
  public onExecute2() {
      var target = this.item as any;
      target[this.targetProperty] = this.propValue;
      return this.$api.update(target).then(obj => {
        this.reload();
      });      
  }  
  public onExecuteAccountSetting(){
    switch (this.accountApiType) {
      case Common.accountApiTypes.freee:
        var query = new Common.GetFreeClientIdQuery();
        this.$api.execute(query).then(rtn => {
          const url = 'https://accounts.secure.freee.co.jp/public_api/authorize?client_id={0}&redirect_uri={1}&state={2}&response_type=code';
          const client_id = rtn;
          var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
          redirect_uri += location.pathname;
          const state = this.$api.license.tenantId + '|' + Common.accountApiTypes.freee.toString();
          location.href = encodeURI(String.format(url,client_id,redirect_uri,state));
        });
        break;
      case Common.accountApiTypes.none:
        var target = this.item as Common.TenantSettings;
        target.accountApiType = Common.accountApiTypes.none;
        target.accountSettingValue = "";
        target.accountSettingId = "";
        target.accountAccessToken = '';
        target.accountAccessTokenExpire = null;
        target.dealApiType = Common.dealApiTypes.none;
        return this.$api.update(target).then(obj => {
          this.reload();
        });      
    }
  }
  public onExecuteFreeeSetting(){
    if(this.freeCompayId == '')
    {
        this.$api.modal.showDialog('無効な操作','連携の設定に失敗しました。');
        return;
    }
    var query = new Common.AccountSettingQuery();
    query.accountSettingId = this.freeCompayId;
    query.useDealsApiFreee = this.freeeDealsApi;
    query.accountSettingValue = this.freeCompanies.filter(obj => obj.value == this.freeCompayId).map(obj => obj.text)[0];
    query.accountApiType = Common.accountApiTypes.freee;
    this.$api.execute(query).then(rtn => {
      this.reload();
      this.$api.modal.showDialog('メッセージ','連携の設定が完了しました。');
    });
  }
  public accountApiTypeIsFreee(){
    return this.item.accountApiType == Common.accountApiTypes.freee;
  }
  public accoutApiSetting(){
    this.showAccountSettingDialog = true;
  }

  public moneyLookApiSetting(){
    this.showMoneyLookDialog = true;
  }
  public async onExecuteMoneyLookSetting(){
    var query = new Common.GetMoneyLookRequestTokenQuery();
    query.oauthConsumerKey = this.moneyLookConsumerKey;
    query.oauthConsumerSecret = this.moneyLookConsumerSecret;

    var oauth_token = "";
    var oauth_token_secret = "";
    await this.$api.execute(query).then(res => {
      oauth_token=res.oauth_token;
      oauth_token_secret=res.oauth_token_secret;
      });
    var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
    redirect_uri += location.pathname;
    const loginUrl = 'https://biz.moneylook.jp/oauth/v2/authorize.auth?oauth_token={0}&oauth_callback={1}';
    const state = this.$api.license.tenantId + '|' + Common.accountApiTypes.moneyLook.toString();
    const callbakUrl = String.format('{0}?state={1}',redirect_uri, state);
    location.href = encodeURI(String.format(loginUrl,oauth_token,callbakUrl));
  }

  // 期首日
  public beginningTermDate(): Date{
    var beginningTerm = new Date(this.$api.license.signupTimestamp);
    var setting = this.item as Common.TenantSettings;
    beginningTerm.setMonth(setting.startMonth - 1);
    if(this.$api.license.signupTimestamp < beginningTerm) beginningTerm.setFullYear(beginningTerm.getFullYear() -1 );
    beginningTerm.setDate(1);
    return beginningTerm;
  }
  public migrationDataUpload(){
    this.dataMigrationType = Common.dataMigrationTypes.none;
    this.migrationDataSegment = null;
    this.migrationDataPic = null;
    this.bankAccount = null;
    var today:Date = new Date().getCalendarDate();
    this.migrationDate = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    (this.$refs.dataMigrationDialog as Components.ListDialog).showDialog();
  }

  public databaseBackupDescription : string = "";
  public showDatabaseBackupDialog: boolean = false;
  public showDatabaseBackup(){
    this.databaseBackupDescription = "";
    this.showDatabaseBackupDialog = true;
  }
  public databaseBackup(){
    this.$api.modal.showDialog('確認メッセージ','データベースのバックアップを取得します。バックアップはストレージに保存され、ストレージ利用量に加算されます。\r\nよろしいですか？',false,'実行','キャンセル').then(()=>{
      this.$api.execute(new Common.DatabaseBackupQuery(this.databaseBackupDescription)).then(()=>{
        this.$api.modal.show('処理結果','バックアップを開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
        return true;
      }).catch(()=>{return false;});
    });
  }
  
  public databaseRestoration(){
    var query = new Common.LoaddatabaseBackupFile();
    this.$api.execute(query).then(res => {
      (this.$refs.backUpFileDialog as Components.ListDialog).items = res;
      (this.$refs.backUpFileDialog as Components.ListDialog).showDialog();
    });
  }
  public backupOperation(list: Array<Common.UploadFile>, index:number){
    if(index == 1 && this.item.electronicBookMode == true){
      this.$api.modal.showDialog('無効な操作','電子帳簿保存法対応をしている場合、データベースの復元はできません。\r\n電子帳簿保存法対応を解除してから実施してください。');
      return;
    }

    var target =list.filter(obj => obj.isTarget == true);
    if(target.length == 0){
      this.$api.modal.showDialog('無効な操作','対象を選択して下さい。');
      return;
    }
    if(index == 0)          // バックアップの削除処理
    {
      this.$api.modal.showDialog('確認メッセージ','バックアップファイルの削除を行います。\r\nこの操作は取り消せません。本当によろしいですか？',false,'実行','キャンセル').then(()=>{
        this.$api.execute(new Common.DatabaseBackupDeleteQuery(target)).then(()=>{
          this.$api.modal.show('処理結果','バックアップファイルの削除を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
        }).catch(()=>{return false;});
        (this.$refs.backUpFileDialog as Components.ListDialog).closeDialog();
      });
    }
    else if(index == 1)   // バックアップの復元処理
    {
      if(target.length == 1){
        this.$api.modal.showDialog('確認メッセージ','データベースの復元を行います。復元前のデータは全て削除されます。\r\nこの操作は取り消せません。本当によろしいですか？',false,'実行','キャンセル').then(()=>{
          this.$api.execute(new Common.RestoreDataBaseQuery(target[0])).then(()=>{
            this.$api.modal.showDialog('処理結果','復元処理を開始しました。\r\n復元中は操作やログインをすることができなくなります。\r\n時間を置いて再度ログインしてください。').then(()=>{this.$api.auth.logout();});
          }).catch(()=>{return false;});
        });
      }
      else{
        this.$api.modal.showDialog('無効な操作','復元対象を1つだけ選択して下さい。');
      }
    }
  }
  

  public migrationDataSegment: Common.Segment = null;
  public migrationDataPic: Common.User = null;
  public bankAccount: Common.BankAccount = null;
  public migrationDate: Date = new Date();

  public async onExecuteMigrationDataImport(){
    if(this.dataMigrationType==Common.dataMigrationTypes.none) return true;
    
    let customer= this.$refs.file_customer?(this.$refs.file_customer as any).files as FileList : null;
    let supplier = this.$refs.file_supplier?(this.$refs.file_supplier as any).files as FileList : null;
    let receiver = this.$refs.file_receiver?(this.$refs.file_receiver as any).files as FileList : null;
    let warehouse = this.$refs.file_warehouse?(this.$refs.file_warehouse as any).files as FileList : null;
    let commodity = this.$refs.file_commodity?(this.$refs.file_commodity as any).files as FileList : null;
    let salesDelivery = this.$refs.file_sales?(this.$refs.file_sales as any).files as FileList : null;
    let purchaseDelivery = this.$refs.file_purchase?(this.$refs.file_purchase as any).files as FileList : null;
    let stockBalance = this.$refs.file_stock?(this.$refs.file_stock as any).files as FileList : null;

    let dt = new DataTransfer();
    let importPattern : number = 0;
    if(this.dataMigrationType == Common.dataMigrationTypes.yayoi){
      if(customer.length > 0){
        dt.items.add(customer[0]);
        importPattern+=Common.yayoiDataMigrationClass.customer;
      }
      if(supplier.length > 0){
        dt.items.add(supplier[0]);
        importPattern+=Common.yayoiDataMigrationClass.supplier;
      }
      if(receiver.length > 0){
        dt.items.add(receiver[0]);
        importPattern+=Common.yayoiDataMigrationClass.receiver;
      }
      if(warehouse.length > 0){
        dt.items.add(warehouse[0]);
        importPattern+=Common.yayoiDataMigrationClass.warehouse;
      }
      if(commodity.length > 0){
        dt.items.add(commodity[0]);
        importPattern+=Common.yayoiDataMigrationClass.commodity;
      }
    }
    else if(this.dataMigrationType == Common.dataMigrationTypes.yayoi_item){
      if(purchaseDelivery.length > 0){
        dt.items.add(purchaseDelivery[0]);
        importPattern+=Common.yayoiDataMigrationClass.purchaseDelivery;
      }
      if(salesDelivery.length > 0){
        dt.items.add(salesDelivery[0]);
        importPattern+=Common.yayoiDataMigrationClass.salesDelivery;
      }
    }
    else if(this.dataMigrationType == Common.dataMigrationTypes.yayoi_stock){
      if(stockBalance.length > 0){
        dt.items.add(stockBalance[0]);
        importPattern+=Common.yayoiDataMigrationClass.stockBalance;
      }
      if(this.migrationDate.getDate() != 1) {
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','移行日は月初(1日)を指定してください。').then(()=>{return false;});
      }
    }
    if(importPattern==0){
      this.$api.closeWaitCursor();
      return this.$api.modal.showDialog('無効な操作','ファイルが選択されていません。').then(()=>{return false;});
    }
    
    let query = new Common.YayoiDataMigrationQuery(this.dataMigrationType, importPattern);
    if(this.dataMigrationType == Common.dataMigrationTypes.yayoi_item || this.dataMigrationType == Common.dataMigrationTypes.yayoi_stock){
      query.migrationDataSegment = this.migrationDataSegment;
      query.migrationDataPic = this.migrationDataPic;
      query.bankAccount = this.bankAccount;
    }
    if(this.dataMigrationType == Common.dataMigrationTypes.yayoi_stock){
      query.migrationDate = this.migrationDate;
    }
    if((purchaseDelivery != null && purchaseDelivery.length > 0) || (salesDelivery != null && salesDelivery.length > 0)){
        this.$api.modal.showDialog('確認メッセージ','弥生販売(売上仕入)のインポートをすると、既存の入出荷が全て計上・消込されます。\r\nよろしいですか？',false).then(()=>{
          return this.$api.upload(query ,dt.files).then(res => {
            this.$api.modal.show('処理結果','データインポートを開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
            return true;
          }).catch(()=>{return false;});
        });
    }
    else if(stockBalance != null && stockBalance.length > 0){
        this.$api.modal.showDialog('確認メッセージ','弥生販売(在庫)のインポートをすると、既存の在庫が全て上書きされます。\r\nよろしいですか？',false).then(()=>{
          return this.$api.upload(query ,dt.files).then(res => {
            this.$api.modal.show('処理結果','データインポートを開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
            return true;
          }).catch(()=>{return false;});
        });
    }else{
      return this.$api.upload(query ,dt.files).then(res => {
        this.$api.modal.show('処理結果','データインポートを開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
        return true;
      }).catch(()=>{return false;});
    }
  }
  public sendTestMail() {
    this.$api.modal.showDialog('確認メッセージ','指定されたメール送信設定でログインユーザー宛てにテストメールを送信します。よろしいですか？',false).then(()=>{
      this.$api.execute(new SendTestMailQuery()).then(()=>{
        this.$api.modal.show('処理結果','テストメールを正常に送信しました。メールの受信を確認してください。',true,null);      
      });
    });
  }
  public onIssueApiKey() {
    //ランダムな文字列を発行する
    this.item.apiKey = this.getUUID();
    (this.$refs.apiKey as Vue).$forceUpdate();
  }

  private getUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }    

  //SMTPサーバー設定
  public showSmtpDialog:boolean = false;  
  public smtpSetup: Common.SmtpSetupQuery = new Common.SmtpSetupQuery();//バインドされるため初期化しておく
  public buttonTitle:string = null;
  public startSmtpSetting(){
    this.smtpSetup = new Common.SmtpSetupQuery();
    this.showSmtpDialog = true;    
  }
  public proceedSmtpSetting(){
    if (this.smtpSetup.smtpProviderFlag == Common.SmtpProviderFlags.Default) this.executeSmtpSetting();
    else (this.$refs.smtpSettingsDialog as Components.ListDialog).showDialog();  
      
    
  }
  public executeSmtpSetting(){
     (this.$refs.smtpSettingsDialog as Components.ListDialog).closeDialog();

    if (this.smtpSetup.smtpProviderFlag == Common.SmtpProviderFlags.Office365)
      this.$api.modal.showDialog('メールサーバー設定','Office365認証を開始してよろしいですか？',false).then(()=>{
        //msalリダイレクトバックと同じ形式になる
        const url = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id={0}&redirect_uri={1}&state={2}&scope=https://outlook.office.com/SMTP.Send offline_access';
        const client_id = '8cfbe406-6a59-4534-acd9-3cf5d0841624';
        var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
        redirect_uri += location.pathname;        
        const state = this.$api.license.tenantId + '|' + Common.accountApiTypes.smtp.toString() + '|'+ btoa(JSON.stringify(this.smtpSetup));        
        location.href = encodeURI(String.format(url,client_id,redirect_uri,state));
      });    
    else if (this.smtpSetup.smtpProviderFlag == Common.SmtpProviderFlags.Google){
        //制限付きスコープはGoogleの認証を毎年受ける必要があるため、実装済みだが使用はしない
        const url = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id={0}&redirect_uri={1}&state={2}&scope=https://mail.google.com/&access_type=offline';
        //const url = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id={0}&redirect_uri={1}&state={2}&scope=https://www.googleapis.com/auth/gmail.send&access_type=offline';        
        const client_id = '271591822570-sj88ft03f3tro63usjp8vnef0cmkn6no.apps.googleusercontent.com';

        var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
        redirect_uri += location.pathname;        
        const state = this.$api.license.tenantId + '|' + Common.accountApiTypes.smtp.toString() + '|'+ btoa(JSON.stringify(this.smtpSetup));        
        location.href = encodeURI(String.format(url,client_id,redirect_uri,state));
    }
    else 
      this.$api.modal.showDialog('メールサーバー設定','設定を更新し、テストメールを送信してよろしいですか？',false).then(()=>{
        this.$api.execute(this.smtpSetup).then(res =>{
          this.reload();            
          this.$api.modal.show('メールサーバー設定','設定を更新し、テストメールを送信しました。メールを確認してください。',true,null);
        });
      });
  }
}
